import Splide from "@splidejs/splide";

document.addEventListener( 'DOMContentLoaded', function() {
    const ibbTestimonialSliders = document.querySelectorAll(".ibb-testimonials-splide");
    if (ibbTestimonialSliders) {
        ibbTestimonialSliders.forEach((el) => {
            new Splide(el).mount();
        });        
    };
});